import { MappingCollectionItemT } from 'bovaljaren-models';
import { CSSProperties } from 'react';

export type PolygonMeasurementsT = {
    xMin: number;
    xMid: number;
    xMax: number;
    yMin: number;
    yMid: number;
    yMax: number;
}

const getPolygonAlignment = (pMeasurements: PolygonMeasurementsT): string => {
    // Figure out if polygon is mostly on the left or right hand side of the image.
    if (pMeasurements.xMin > (100 - pMeasurements.xMax)) {
        return 'right';
    }

    return 'left';
};

const getPolygonMeasurements = (mapping?: MappingCollectionItemT): PolygonMeasurementsT => {
    if (!mapping || ! mapping.polycords) {
        return { xMin: 0, xMid: 0, xMax: 0, yMin: 0, yMid: 0, yMax: 0 };
    }

    const polycords = mapping.polycords;
    const xValues = polycords.map(coords => {
        return coords[0];
    });
    const yValues = polycords.map(coords => {
        return coords[1];
    });

    const xMin = Math.min(...xValues);
    const xMax = Math.max(...xValues);
    const xMid = (xMax - ((xMax - xMin) / 2));
    const yMin = Math.min(...yValues);
    const yMax = Math.max(...yValues);
    const yMid = (yMax - ((yMax - yMin) / 2));

    return { xMin, xMax, xMid, yMid, yMax, yMin };

};

const measureImage = (): ({ width: number; height: number}) | undefined => {
    const dimensions = document.querySelector('.responsive-image')?.getBoundingClientRect();

    if (!dimensions || !dimensions.width || !dimensions.height) {
        return undefined;
    }
    const width: number = dimensions.width || 0;
    const height: number = dimensions.height || 0;

    return { width, height };
};

const calculateStyle = (polygonMeasurements: PolygonMeasurementsT, imageDimensions?: {width: number; height: number}, mapping?: MappingCollectionItemT, scale?: number): CSSProperties => {
    if (!mapping) {
        return {};
    }

    if (!imageDimensions?.width) {
        measureImage();
    }

    const style: CSSProperties = {
        top: `calc(${(Math.round(polygonMeasurements.yMid * 100) / 100)}% - 70px`
    };
    const margin = 30 - (15 * (scale || 1) * (scale || 1));

    if (getPolygonAlignment(polygonMeasurements) === 'left') {
        style['left'] = `calc(${(Math.round(polygonMeasurements.xMax * 100) / 100)}% + ${margin}px)`;
    }
    else {
        style['right'] = `calc(${(Math.round((100 - polygonMeasurements.xMin) * 100) / 100)}% + ${margin}px)`;
    }

    return style;
};

const calculateTipStyle = (polygonMeasurements: PolygonMeasurementsT, mapping?: MappingCollectionItemT): CSSProperties => {
    if (!mapping) {
        return {};
    }

    const style: CSSProperties = {
        top: 'calc(50% - 8px)',
        borderTop: '10px solid transparent',
        borderBottom: '10px solid transparent'
    };

    if (getPolygonAlignment(polygonMeasurements) === 'left') {
        style['left'] = '-16px';
        style['borderRightWidth'] = '16px';
    }
    else {
        style['right'] = '-16px';
        style['borderLeftWidth'] = '16px';
    }

    return style;
};

const calculateTipForegroundStyle = (polygonMeasurements: PolygonMeasurementsT, mapping?: MappingCollectionItemT): CSSProperties => {
    if (!mapping) {
        return {};
    }

    const style: CSSProperties = {
        top: 'calc(50% - 3px)',
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent'
    };

    if (getPolygonAlignment(polygonMeasurements) === 'left') {
        style['left'] = '-11px';
        style['borderRightWidth'] = '11px';
    }
    else {
        style['right'] = '-11px';
        style['borderLeftWidth'] = '11px';
    }

    return style;
};


export { calculateStyle, calculateTipForegroundStyle, calculateTipStyle, getPolygonAlignment, measureImage, getPolygonMeasurements };